import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["uUID"];
/* hs-eslint ignored failing-rules */
/* eslint-disable prefer-const */

import { createRpcClientV2, readUnhandledEnumCase } from 'rpc-client-utils';
import appAuthApiClient from 'hub-http/clients/apiClient';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { getAlarmsRpc as getAppAlarmsRpc } from '../../__generated__/chirp/com/hubspot/firealarm/rpc/alarms/FireAlarmReadRpc';
import { getAlarmsRpc as getExternalAlarmsRpc } from '../../__generated__/chirp/com/hubspot/firealarm/rpc/alarms/FireAlarmReadRpc-external';
import Alarm from '../model/Alarm';
// @ts-expect-error not typescript
import Severity from '../constants/Severity';
import ApiError from './ApiError';
const appAuthChirpClient = createRpcClientV2({
  hubHttpClient: appAuthApiClient
});
const noAuthChirpClient = createRpcClientV2({
  hubHttpClient: noAuthApiClient
});
class AlarmApi {
  constructor(dom, storage, events) {
    this.dom = dom;
    this.storage = storage;
    this.events = events;
  }
  getAlarms(appName, callback) {
    const {
      dom,
      storage,
      events
    } = this;
    const hasAppAuth = /^\/(?:[A-Za-z0-9-_]*)\/(\d+)(?:\/|$)/.test(window.location.pathname);
    const i18nWindow = window;
    const chirpClient = hasAppAuth ? appAuthChirpClient : noAuthChirpClient;
    const rpc = hasAppAuth ? getAppAlarmsRpc : getExternalAlarmsRpc;
    void chirpClient.call(rpc, {
      request: {
        appName,
        languageKey: i18nWindow.I18n && i18nWindow.I18n.langEnabled ? i18nWindow.I18n.lang : 'en'
      }
    }).then(({
      alarms
    }) => {
      callback(alarms.map(_ref => {
        let {
            uUID
          } = _ref,
          alarmData = _objectWithoutPropertiesLoose(_ref, _excluded);
        const severity = readUnhandledEnumCase(alarmData.severity);
        if (!Severity.getByKey(severity)) {
          return null;
        }
        return new Alarm(Object.assign({}, alarmData, {
          severity,
          uuid: uUID === null || uUID === void 0 ? void 0 : uUID.value
        }), dom, storage, events);
      }).filter(alarm => alarm !== null), null);
    }, error => {
      callback(null, new ApiError(error));
    });
    return true;
  }
}
export default AlarmApi;